import {defaultConfiguration, defaultConfigurationModules, IConfiguration} from "../configuration.state";
const CONFIGURATION_UNICREDIT:IConfiguration = {
  ...defaultConfiguration,
  api: {
    ...defaultConfiguration.api,
    protocol: 'https',
    port: '443'
  },
  theme: 'unicredit',
  language: {
    defaultLang: 'ru',
    showLang: true,
    langList: ['en', 'ru', 'ro', 'ua']
  },
  pagesConfig: {
    ...defaultConfigurationModules,
    login:{
      ...defaultConfigurationModules.login,
      loginType: 'common',
      supportEmail: 'support@redfactory.io',
      goFAQ: '',

      enableSelfRegistration: true,
      enableGoogleSignIn: true,
      showTutorialVideo: false,
      showTryDemoButton: true,
      showAboutUsButton: true,
      showContacts: true,
      showContactOnlyEmail: true,
      contactsConfig: {
        showViber: false,
        showPhone: false,
        showEmail: true
      }
    },
    main:{
      showSupportBlock: false
    },
    dataLedger: {
      ...defaultConfigurationModules.dataLedger,
      showAddressForPartner: true
    },
    chat: {
      enabled: true
    }
  }
};
export const CONFIGURATION_UNICREDIT_DEV:IConfiguration = {
  ...CONFIGURATION_UNICREDIT
};
export const CONFIGURATION_UNICREDIT_PROD:IConfiguration = {
  ...CONFIGURATION_UNICREDIT
};
